<template>
  <div>
    <el-form
      :model="messageForm"
      label-width="100px"
      label-position="left"
      :rules="messageRules"
      ref="messageFormRef"
      class="message-form"
      size="small"
    >
      <el-form-item label="接收人" prop="remindingUserIds">
        <template v-if="!info.isOtherPageMessageTip">
          <el-select
            v-if="submitUrl !== '/system/message2/reply'"
            v-model="messageForm.remindingUserIds"
            multiple
            clearable
            filterable
            collapse-tags
            :max-collapse-tags="10"
            placeholder="请选择"
            @change="changeSelect"
          >
            <div class="checkbox-wrapper">
              <el-checkbox v-model="checked" @change.native="checkChange">全选</el-checkbox>
            </div>
            <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"> </el-option>
          </el-select>
          <span v-else>{{
            info.remindingUserName === "all" || info.forwardType == '0' ? info.createUserName : info.remindingUserName
          }}</span>
        </template>
        <span v-else>{{ info.clientManagerUserName || info.userName }}</span>
      </el-form-item>
      <el-form-item label="模板:">
        <el-select v-model="messageForm.remindingTitleJa" placeholder="请选择" @change="onChange" clearable filterable @clear="clearTemplate">
          <el-option v-for="item in templateList" :key="item.id" :value="item.remindingTitle" :label="item.remindingTitle"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="remindingTitle">
        <el-input v-model="messageForm.remindingTitle"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="remindingContent">
        <quill-editor ref="quillEditorRef" :options="editorOption" v-model="messageForm.remindingContent" />
      </el-form-item>
      <el-form-item label-width="0px">
        <el-col :span="6">
          <el-form-item label="关联订单：" prop="orderId">
            <el-input v-model="messageForm.orderId" @blur="getGoodsCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="商品编码：" prop="goodsCode">
            <el-input v-model="messageForm.goodsCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="关联批次：" prop="containerBatchNo">
            <el-input v-model="messageForm.containerBatchNo"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="附件：">
        <el-upload
          :http-request="handleUpload"
          action=""
          multiple
          :limit="9"
          :before-upload="beforeUploadFile"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx,.pdf,.png,.jpg,.jpeg,.mp4,.ai,.xlsm"
        >
          <el-button class="search-btn btn-blue upload-btn">上传</el-button>
        </el-upload>
        <div class="file-list-wrap">
          <div class="file-list-item" v-for="item in fileList" :key="item.url">
            <div class="img-wrap">
              <img v-if="['.xls', '.xlsx', '.xlsm'].includes(item.suffix)" src="@/assets/images/icon_excel.png" alt="" />
              <img v-else-if="item.suffix === '.pdf'" src="@/assets/images/icon_pdf.png" alt="" />
              <video
                v-else-if="item.suffix === '.mp4'"
                :src="item.url"
                :width="100"
                :height="100"
                controlsList="nodownload noplaybackrate"
                disablepictureinpicture
              ></video>
              <img v-else :src="item.url" alt="" />
              <div class="operation">
                <i v-if="!['.xls', '.xlsx', '.pdf', '.xlsm'].includes(item.suffix)" class="el-icon-circle-plus-outline" @click="handleReview(item)"></i>
                <i class="el-icon-delete" @click="handleRemove(item)"></i>
              </div>
            </div>
            <span class="text-hidden">{{ item.name }}</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog title="" append-to-body :visible.sync="showPictureView" width="30%" show-close center close-on-click-modal @close="closeImgViewer">
      <video v-if="isVideo" :src="imgurl" width="100%" controls controlsList="nodownload noplaybackrate" disablepictureinpicture></video>
      <img v-else width="100%" height="auto" :src="imgurl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "MessageForm",
  props: {
    submitUrl: {
      type: String,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    messageGroup: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      messageForm: {
        remindingUserIds: [],
        remindingTitleJa: "",
        remindingTitle: "",
        remindingContent: "",
        orderId: "",
        goodsCode: "",
        containerBatchNo: "",
      },
      fileList: [],
      userList: [],
      messageRules: {
        remindingUserIds: [{ required: true, message: "请选择接收人", trigger: "blur" }],
        remindingTitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
        remindingContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
        orderId: [{ require: false, pattern: /^[A-Za-z0-9]+$/, message: "只能输入数字和字母", trigger: "blur" }],
        containerBatchNo: [{ require: false, pattern: /^[A-Za-z0-9]+$/, message: "只能输入数字和字母", trigger: "blur" }],
      },
      editorOption: {
        modules: {
          clipboard: {
            matchers: [["img", this.handlePasteImg]],
          },
          toolbar: false,
        },
      },
      username: "",
      imgurl: "",
      showPictureView: false,
      isVideo: false,
      templateList: [],
      checked: false,
    };
  },
  mounted() {
    this.username = sessionStorage.getItem("username");
    this.getTemplateList();
    this.initMessageForm();
    this.getUserList();
  },
  watch: {
    "info.id": function (val, old) {
      if (val !== old) {
        this.initMessageForm();
      }
    },
    messageGroup: {
      handler: function () {
        this.initMessageForm();
      },
      deep: true,
    },
  },
  methods: {
    async getGoodsCode() {
      this.$http.get("/purchase/getGoodsCode",{params: {id: this.messageForm.orderId}}).then((res) => {
        this.messageForm.goodsCode = res.data.data;
      })
    },
    clearTemplate() {
      this.messageForm.remindingTitleJa = "";
      this.messageForm.remindingTitle = "";
      this.messageForm.remindingContent = "";
    },
    checkChange() {
      let resValues = this.userList.map((item) => item.userId);
      if (!this.checked) {
        this.messageForm.remindingUserIds = [];
      } else {
        let res = [...resValues];
        this.messageForm.remindingUserIds = res;
      }
    },
    changeSelect(val) {
      let resValues = this.userList.map((item) => item.userId);
      // 如果选择数组长度等于options的长度，checkbox设为true，反之设为false
      if (val.length === resValues.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.messageForm.remindingUserIds = val;
    },
    onChange(val) {
      const obj = this.templateList.find((item) => item.remindingTitle === val);
      this.messageForm.remindingTitle = obj.remindingTitleJa;
      this.messageForm.remindingContent = obj.remindingContentJa.replaceAll("\n", "<br/>");
    },
    getTemplateList() {
      this.$http.get("template/message/getList").then((res) => {
        this.templateList = res.data.data;
      });
    },
    handlePasteImg(_, delta) {
      let ops = [];
      delta.ops.forEach(async (op) => {
        if (op.insert && typeof op.insert !== "string") {
          // 如果粘贴了图片，这里会是一个对象
          if (op.insert.image) {
            if (op.insert.image.includes(";base64")) {
              let file = this.dataURLtoFile(op.insert.image, `paste-${Math.random().toString(36).slice(-8)}.jpg`);
              let fileFormdata = new FormData();
              fileFormdata.append("file", file);
              this.$http.post("cmUser/message/uploadFile", fileFormdata).then(({ data: res }) => {
                if (res.code === 200) {
                  const { filePath } = res.data;
                  let quill = this.$refs.quillEditorRef.quill; // 获取富文本对象
                  let length = quill.getSelection().index; // 获取编辑器光标位置
                  quill.insertEmbed(length, "image", filePath); // 插入图片  图片地址
                  quill.setSelection(length + 1);
                }
              });
            }
          }
        }
      });
      delta.ops = ops; // 不加会报错
      return delta;
    },
    dataURLtoFile(dataurl, name) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },
    initMessageForm() {
      this.messageForm.orderId = this.info.orderId;
      this.messageForm.containerBatchNo = this.info.containerBatchNo;
      if(this.info.newRemindingTitle){
        this.messageForm.remindingTitle = this.info.newRemindingTitle ? `Re：${this.info.newRemindingTitle}` : "";
      }else {
        this.messageForm.remindingTitle = this.info.remindingTitle ? `Re：${this.info.remindingTitle}` : "";
      }
      this.getGoodsCode();
      // this.messageForm.remindingTitle = this.info.remindingTitle ? `Re：${this.info.remindingTitle}` : "";
      // const replyArray = this.messageGroup.length && this.messageGroup.filter((item) => item.createUserName !== this.username && item.forwardType == 0);
      // if (replyArray && replyArray.length) {
      //   this.messageForm.remindingTitle = `Re：${replyArray[0].remindingTitle}`;
      // } else {
      //   this.messageForm.remindingTitle = "";
      // }
    },
    getUserList() {
      this.$http.get("customer/findAllCustomer").then((res) => {
        if (res.data.code === 200) {
          // this.userList = res.data.data;
          this.userList = res.data.data.filter(item => {
            return !item.clientMasterUserName
          })
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleUpload(file) {
      let fileFormdata = new FormData();
      fileFormdata.append("file", file.file);
      this.$http.post("cmUser/message/uploadFile", fileFormdata).then(({ data: res }) => {
        if (res.code === 200) {
          const { fileName, filePath } = res.data;
          const suffix = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
          const obj = {
            name: fileName,
            url: filePath,
            suffix,
          };
          this.fileList.push(obj);
        }
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    },
    beforeUploadFile(file) {
      const applyTypeArray = [".xls", ".xlsx", ".pdf", ".png", ".jpg", ".jpeg", ".mp4", ".ai", ".xlsm"];
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      // const size = file.size / 1024 / 1024
      if (!applyTypeArray.includes(extension)) {
        this.$message.warning("只能上传图片及excel和pdf文件");
        return false;
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    formReset() {
      this.messageForm.remindingTitleJa = "";
      this.fileList = [];
      this.$refs.messageFormRef.resetFields();
      this.initMessageForm();
    },
    submit() {
      const { remindingUserId, isOtherPageMessageTip, userName, forwardType, createUserId } = this.info;
      if (this.submitUrl === "/system/message2/reply") {
        // const replyArray =
        //   this.messageGroup.length &&
        //   this.messageGroup.filter((item) => item.createUserName !== null && item.createUserName !== this.username && item.forwardType == 0);
        // this.messageForm.remindingUserId = replyArray && replyArray.length ? replyArray[0].createUserId : remindingUserId;
        // this.messageForm.remindingUserIds = [this.messageForm.remindingUserId];
        this.messageForm.remindingUserId = forwardType == '0' ? createUserId : remindingUserId;
        this.messageForm.remindingUserIds = [this.messageForm.remindingUserId];
      }
      if (isOtherPageMessageTip) {
        const userInfo = this.userList.filter((item) => item.userName === userName);
        this.messageForm.remindingUserId = userInfo.length ? userInfo[0].userId : "";
        this.messageForm.remindingUserIds = [this.messageForm.remindingUserId];
      }
      this.$refs.messageFormRef.validate((valid) => {
        if (!valid) {
          // this.$message.error("必填项不能为空，请重新填写并提交！");
          return false;
        }
        this.$emit('setLoading');
        this.querySend();
      });
    },
    querySend() {
      const { messageGroupId, remindingUserId, remindingUserName, messagePid, createUserName, createUserId, orderId } = this.info;
      let isCurrentUser;
      if (remindingUserName === "all") {
        isCurrentUser = true;
      } else {
        // isCurrentUser = this.username === remindingUserName;
      }
      const fileModels = this.fileList.map((item) => {
        return {
          fileName: item.name,
          filePath: item.url,
        };
      });
      let params = null;
      if (this.submitUrl === "system/message2/sandMessageNew") {
        const remindingUserIds = this.messageForm.remindingUserIds.join(",");
        params = {
          ...this.messageForm,
          fileModels,
          messageGroupId,
          remindingUserIds,
        };
      } else {
        const userInfo = this.userList.filter((item) => item.userId === this.messageForm.remindingUserId);
        params = {
          ...this.messageForm,
          fileModels,
          messageGroupId,
          // remindingUserId: isCurrentUser ? createUserId : remindingUserId,
          remindingUserName: userInfo.length ? userInfo[0].userName : remindingUserName,
          messagePid,
          orderId: this.messageForm.orderId || orderId,
          remindingUserIds: "",
        };
      }
      this.$http
        .post(this.submitUrl, params)
        .then(({ data: res }) => {
          if (res.code === 200) {
            this.$message.success("消息发送成功");
            this.$emit("refreshData");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$emit('setNoLoading');
          this.$message.error("消息发送失败");
        });
    },
    closeImgViewer() {
      this.showPictureView = false;
    },
    handleReview(item) {
      if (item.suffix === ".mp4") {
        this.isVideo = true;
      } else {
        this.isVideo = false;
      }
      this.imgurl = item.url;
      this.showPictureView = true;
    },
  },
};
</script>
<style lang="less" scoped>
.checkbox-wrapper {
  padding: 8px 20px;
  border-bottom: 1px solid #ccc;
}
.message-form {
  border-bottom: 3px solid #ccc;
  ::v-deep .ql-container {
    height: 150px;
  }
  ::v-deep .ql-editor {
    min-height: 0;
    overflow-y: auto;
  }
}
.upload-btn {
  padding: 9px 40px !important;
}
.file-list-wrap {
  display: flex;
  margin-top: 10px;
  gap: 10px;
  flex-wrap: wrap;
  .file-list-item {
    width: 100px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .img-wrap {
      width: 100px;
      height: 100px;
      border: 1px solid #ccc;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      img {
        height: 100%;
      }
      .operation {
        cursor: pointer;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        transition: opacity 0.3s;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 18px;
        display: flex;
        justify-content: center;
        gap: 20px;
        align-items: center;
        &:hover {
          opacity: 1;
        }
      }
    }
    .text-hidden {
      margin-top: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 18px;
      text-align: center;
    }
  }
}
</style>
